import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=40339180"
import script from "./taskList.vue?vue&type=script&lang=js"
export * from "./taskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40339180')) {
      api.createRecord('40339180', component.options)
    } else {
      api.reload('40339180', component.options)
    }
    module.hot.accept("./taskList.vue?vue&type=template&id=40339180", function () {
      api.rerender('40339180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/redBook/component/taskList.vue"
export default component.exports